// extracted by mini-css-extract-plugin
export default {"container":"Products_container__t-aKR","products":"Products_products__s1aMB","menu":"Products_menu__aOXDx","list":"Products_list__N8538","product":"Products_product__q3f18"};